export enum Sites {
    CLASH = "clash",
    ROOBET = "roobet",
    CSGOBIG = "csgobig",
    SHOCK = "shock",
    STAKE = "stake",
}